import React, { Component } from 'react';
import * as PropTypes from 'prop-types';
import { I18nextProvider, Translation } from 'react-i18next';
import { I18nProvider } from 'gatsby-i18n';
import setupI18next from './i18n';
import TranslationContext from './TranslationContext';

const translatePage = (options = {}) => (Comp) => {
  class I18nHOC extends Component {
    constructor(props) {
      super(props);
      const { pageContext = {}, data } = props;

      this.state = {
        ...options,
        data: data || pageContext.data,
      };

      this.i18n = setupI18next(pageContext);
      this.activateLng();
    }

    activateLng() {
      const { pageContext = {} } = this.props;
      const { locale = '' } = pageContext;
      const { data } = this.state;
      this.parseFromContext(data);
      this.i18n.changeLanguage(locale.toUpperCase());
    };

    parseFromContext(data) {
      const { pageContext = {} } = this.props;
      const { locale = '' } = pageContext;
      if (data) {
        const lng = locale.toUpperCase();
        if (!this.i18n.hasResourceBundle(lng, data.ns)) {
          this.i18n.addResourceBundle(lng, data.ns, data.content);
        }
      }
    };

    render() {
      const { ns } = this.state;
      const { pageContext = {} } = this.props;
      const { locale = '' } = pageContext;

      return (
        <I18nextProvider i18n={this.i18n} defaultNS={ns}>
          <I18nProvider {...pageContext}>
            <Translation>
              {(t) => (
                <TranslationContext.Provider value={{ t }}>
                  <Comp {...this.props} locale={locale} />
                </TranslationContext.Provider>
              )}
            </Translation>
          </I18nProvider>
        </I18nextProvider>
      );
    }
  }

  I18nHOC.propTypes = {
    pageContext: PropTypes.objectOf(PropTypes.any).isRequired,
    data: PropTypes.objectOf(PropTypes.any),
  };

  I18nHOC.defaultProps = {
    data: undefined,
  };

  return I18nHOC;
};

export default translatePage;
